import { motion } from "framer-motion";
import { ChapterHeading } from "@/components/ChapterHeading";
import { EXPERTISE } from "@/data/profile";

export const Expertise = () => (
  <section id="expertise" data-testid="expertise-section" className="section-dark border-t hairline px-6 md:px-12 py-24 md:py-40">
    <ChapterHeading num="04" label="Expertise" title={["What twenty years", "on deck teaches you"]} />
    <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-4 border-t border-l hairline">
      {EXPERTISE.map((e, i) => (
        <motion.div
          key={e.code}
          data-testid={`expertise-${e.code.toLowerCase()}`}
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-5% 0px" }}
          transition={{ duration: 0.7, delay: i * 0.08, ease: [0.76, 0, 0.24, 1] }}
          className={`group relative border-r border-b hairline min-h-[360px] flex flex-col justify-end overflow-hidden ${e.span}`}
        >
          <img
            src={e.image}
            alt={e.title}
            loading="lazy"
            className="img-treat absolute inset-0 h-full w-full object-cover opacity-45 group-hover:opacity-80 group-hover:scale-105 transition-[opacity,transform] duration-700 ease-out"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1b2229] via-[#1b2229]/60 to-transparent" />
          <span className="absolute inset-x-0 bottom-0 h-0 bg-[var(--accent)] transition-[height] duration-500 ease-out group-hover:h-1 z-10" />
          <div className="absolute top-0 inset-x-0 flex justify-between items-start p-8 md:p-10 z-10">
            <span className="eyebrow">{e.code}</span>
            <span className="eyebrow">0{i + 1}</span>
          </div>
          <div className="relative z-10 p-8 md:p-10">
            <h3 className="font-display uppercase text-2xl md:text-3xl leading-none">{e.title}</h3>
            <p className="mt-4 text-sm text-muted leading-relaxed max-w-md">{e.body}</p>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);
